import { Checkbox, MenuItem, Typography, useTheme } from "@mui/material";
import { FC, memo } from "react";

export interface FilterSelectOptionProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  showBorder?: boolean;
}

export const MENU_ITEM_HEIGHT = 32;

export const FilterSelectOption: FC<FilterSelectOptionProps> = memo(
  ({ label, isSelected, onClick, showBorder = false }) => {
    const theme = useTheme();

    return (
      <MenuItem
        dense
        onClick={onClick}
        sx={{
          height: MENU_ITEM_HEIGHT,
          paddingX: 0.5,
          ...(showBorder
            ? {
                borderBottom: 1,
                borderColor: "divider",
                paddingBottom: "8px",
                height: 40,
              }
            : {}),
        }}
      >
        <Checkbox
          checked={isSelected}
          sx={{
            padding: "6px",
            "& .MuiSvgIcon-root": {
              color: theme.colors.primary[5],
              fontSize: 20,
            },
          }}
        />
        <Typography
          color={theme.colors.text[6]}
          fontSize={12}
          fontWeight={500}
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </Typography>
      </MenuItem>
    );
  },
);
